import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './PragroupHome.css';
import homeLogo from '../../../../assets/newlogo/logo-home.png';
import MobilesPic from '../../../../assets/mobiles.png';
const FAQ_ITEMS = [
  {
    q: 'What is PRA Group Wallet?',
    a: 'PRA Group Wallet is a secure, easy-to-use platform for managing, sending, and receiving cryptocurrencies. It supports multiple tokens and offers advanced security features to protect your digital assets.',
  },
  {
    q: 'How do I get started?',
    a: "Simply register online or download the app, create an account, and follow the setup instructions. You'll be able to securely store, send, and receive a wide range of cryptocurrencies in just a few steps.",
  },
  {
    q: 'Is my crypto safe in PRA Group Wallet?',
    a: 'Yes, your crypto is protected with top-level encryption, multi-layer authentication, and cold storage solutions, ensuring maximum security for your digital assets.',
  },
  {
    q: 'What cryptocurrencies are supported?',
    a: 'PRA Group Wallet supports a wide variety of cryptocurrencies, including Bitcoin, Ethereum, and many popular altcoins. Check our supported tokens list for the full range of assets you can store and manage.',
  },
  {
    q: 'Can I stake my crypto in PRA Group?',
    a: 'Yes, PRA Group offers a simple staking option that allows you to earn rewards by staking your tokens directly within the app. Choose your desired crypto and start staking to maximize your returns.',
  },
  {
    q: 'Can I connect my bank account or credit card?',
    a: 'Yes, PRA Group allows you to link your bank account or credit card for easy purchasing and transferring of cryptocurrencies. Enjoy a simple, secure way to fund your wallet and manage your assets.',
  },
];

export default function PragroupHome() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState(null);
  const [showDesktopActions, setShowDesktopActions] = useState(false);
  const observerRef = useRef(null);

  useEffect(() => {
    const checkWidth = () => setShowDesktopActions(window.innerWidth >= 768);
    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        setTimeout(() => {
          const el = document.querySelector(hash);
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
      }
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const targets = document.querySelectorAll(
      '.pg-home .pg-home-feature-card, .pg-home .pg-home-stats__item, .pg-home .pg-home-faq-item, .pg-home .pg-home-cta-banner, .pg-home .pg-home-security__grid'
    );
    if (reducedMotion) {
      targets.forEach((el) => {
        el.style.opacity = '1';
        el.style.transform = 'none';
        el.style.transition = 'none';
      });
      return;
    }
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.style.opacity = '1';
            e.target.style.transform = 'translateY(0)';
          }
        });
      },
      { threshold: 0.1 }
    );
    targets.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 500ms ease, transform 500ms ease';
      observerRef.current.observe(el);
    });
    return () => observerRef.current?.disconnect();
  }, []);

  const closeMobileNav = () => {
    setMobileNavOpen(false);
  };

  const toggleFaq = (index) => {
    setOpenFaqIndex((prev) => (prev === index ? null : index));
  };

  // Live price state and helpers
  const TOKENS = [
    { id: 'bitcoin', symbol: 'BTC', name: 'Bitcoin', icon: '₿', iconClass: 'pg-home-token-icon--btc' },
    { id: 'ethereum', symbol: 'ETH', name: 'Ethereum', icon: 'Ξ', iconClass: 'pg-home-token-icon--eth' },
    { id: 'solana', symbol: 'SOL', name: 'Solana', icon: '◦', iconClass: 'pg-home-token-icon--sol' },
    { id: 'tether', symbol: 'USDT', name: 'Tether', icon: '₮', iconClass: 'pg-home-token-icon--usdt' },
  ];

  const [prices, setPrices] = useState({});

  const formatMarketCap = (v) => {
    if (!v && v !== 0) return '—';
    const trillion = 1_000_000_000_000;
    const billion = 1_000_000_000;
    const million = 1_000_000;
    if (v >= trillion) return `$${(v / trillion).toFixed(2)}T`;
    if (v >= billion) return `$${(v / billion).toFixed(2)}B`;
    if (v >= million) return `$${(v / million).toFixed(2)}M`;
    return `$${Number(v).toLocaleString('en-US')}`;
  };

  useEffect(() => {
    let mounted = true;
    const fetchPrices = async () => {
      try {
        const ids = TOKENS.map((t) => t.id).join(',');
        const url = `https://api.coingecko.com/api/v3/simple/price?ids=${ids}&vs_currencies=usd&include_24hr_change=true&include_market_cap=true`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Failed to fetch prices');
        const data = await res.json();
        if (mounted) setPrices(data);
      } catch (err) {
        // silently fail; keep previous values
      }
    };
    fetchPrices();
    const id = setInterval(fetchPrices, 60000); // refresh every 60s
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  return (
    <div className="pg-home">
      <nav className="pg-home-nav" role="navigation" aria-label="Main navigation">
        <div className="pg-home-container pg-home-nav__inner">
          <Link to="/" className="pg-home-nav__logo" aria-label="PRA Group Home">
            <img style={{width:"80px"}} src={homeLogo} alt="PRA Group Logo" />
          </Link>
          <ul className="pg-home-nav__links">
            <li><a href="#features">Features</a></li>
            <li><a href="#security">Security</a></li>
            <li><a href="#portfolio">Portfolio</a></li>
            <li><a href="#faq">FAQ</a></li>
          </ul>
          <div className="pg-home-nav__actions">
            <Link to="/auth/login" className="pg-home-btn pg-home-btn-outline" style={{ display: showDesktopActions ? '' : 'none' }}>Sign In</Link>
            <Link to="/auth/signup" className="pg-home-btn pg-home-btn-primary" style={{ display: showDesktopActions ? '' : 'none' }}>Get Started</Link>
            <button
              type="button"
              className="pg-home-nav__hamburger"
              aria-label="Toggle menu"
              aria-expanded={mobileNavOpen}
              onClick={() => setMobileNavOpen(!mobileNavOpen)}
            >
              <span /><span /><span />
            </button>
          </div>
        </div>
      </nav>

      <div className={`pg-home-mobile-nav ${mobileNavOpen ? 'pg-home-mobile-nav--open' : ''}`} aria-hidden={!mobileNavOpen}>
        <a href="#features" onClick={closeMobileNav}>Features</a>
        <a href="#security" onClick={closeMobileNav}>Security</a>
        <a href="#portfolio" onClick={closeMobileNav}>Portfolio</a>
        <a href="#faq" onClick={closeMobileNav}>FAQ</a>
        <Link to="/auth/signup" className="pg-home-btn pg-home-btn-primary" style={{ marginTop: '1rem' }} onClick={closeMobileNav}>Get Started</Link>
      </div>

      <section className="pg-home-hero">
        <div className="pg-home-hero__bg">
          <div className="pg-home-glow-teal" />
          <div className="pg-home-glow-purple" />
        </div>
        <div className="pg-home-container">
          <div className="pg-home-hero__layout">
            <div className="pg-home-hero__content">
              <span className="pg-home-badge">Now in Beta</span>
              <h1 className="pg-home-hero__title">The Ultimate <span>Crypto Wallet</span></h1>
              <p className="pg-home-hero__sub" style={{marginLeft:"0"}}>
                A trusted platform built to streamline your cryptocurrency journey — offering secure wallets, lightning-fast exchanges, and real-time market insights.
              </p>
              <p className="pg-home-hero__sub" style={{marginLeft:"0"}}>
 Registered office address: Level 11 Riverside House, 2a Southwark Bridge Road, London, England, SE1 9HA
              </p>
              <div className="pg-home-hero__actions">
                <Link to="/auth/signup" className="pg-home-btn pg-home-btn-primary">Create Free Account</Link>
                <a href="#features" className="pg-home-btn pg-home-btn-outline">Explore Features</a>
              </div>
            </div>
            <div className="pg-home-hero__visual" aria-hidden="true">
              <img src={MobilesPic} alt="PRA Group mobile app preview" className="pg-home-hero__image" />
            </div>
          </div>
        </div>
      </section>

      <section className="pg-home-section pg-home-stats">
        <div className="pg-home-container">
          <div className="pg-home-stats__grid">
            <div className="pg-home-stats__item"><div className="pg-home-stats__number">12.4K+</div><div className="pg-home-stats__label">Active Users</div></div>
            <div className="pg-home-stats__item"><div className="pg-home-stats__number">$84M+</div><div className="pg-home-stats__label">Assets Managed</div></div>
            <div className="pg-home-stats__item"><div className="pg-home-stats__number">150+</div><div className="pg-home-stats__label">Tokens Supported</div></div>
            <div className="pg-home-stats__item"><div className="pg-home-stats__number">99.9%</div><div className="pg-home-stats__label">Uptime</div></div>
          </div>
        </div>
      </section>

      <section className="pg-home-section" id="features">
        <div className="pg-home-container">
          <div className="pg-home-features__header">
            <span className="pg-home-badge">Main Features</span>
            <h2 style={{ marginTop: '1rem' }}>A New Generation Wallet</h2>
            <p>Experience the ultimate combination of security, simplicity, and speed for all your crypto needs.</p>
          </div>
          <div className="pg-home-features__grid">
            <div className="pg-home-feature-card"><div className="pg-home-feature-card__icon pg-home-feature-card__icon--teal">&#127912;</div><h3>User-Friendly Design</h3><p>Effortlessly manage your crypto with an intuitive interface built for everyone.</p></div>
            <div className="pg-home-feature-card"><div className="pg-home-feature-card__icon pg-home-feature-card__icon--purple">&#128274;</div><h3>Top-Tier Security</h3><p>Advanced encryption to safeguard your digital assets at every layer.</p></div>
            <div className="pg-home-feature-card"><div className="pg-home-feature-card__icon pg-home-feature-card__icon--teal">&#128273;</div><h3>Password Protection</h3><p>Secure access with robust, customizable password options.</p></div>
            <div className="pg-home-feature-card"><div className="pg-home-feature-card__icon pg-home-feature-card__icon--purple">&#128142;</div><h3>Multi-Token Support</h3><p>Store, send, and stake a wide variety of cryptocurrencies.</p></div>
            <div className="pg-home-feature-card"><div className="pg-home-feature-card__icon pg-home-feature-card__icon--teal">&#128737;&#65039;</div><h3>Unmatched Safety</h3><p>Cold storage solutions to keep your funds secure from threats.</p></div>
            <div className="pg-home-feature-card"><div className="pg-home-feature-card__icon pg-home-feature-card__icon--purple">&#128200;</div><h3>Staking+</h3><p>Earn rewards by staking your tokens directly in the wallet.</p></div>
          </div>
        </div>
      </section>

      <section className="pg-home-section pg-home-security" id="security">
        <div className="pg-home-container">
          <div className="pg-home-glow-teal" style={{ position: 'absolute', top: '20%', right: '-15%' }} />
          <div className="pg-home-security__grid">
            <div className="pg-home-security__visual"><div className="pg-home-security__visual-inner">&#128737;&#65039;</div></div>
            <div className="pg-home-security__content">
              <span className="pg-home-badge">Uncompromising Protection</span>
              <h2 style={{ marginTop: '1rem' }}>Backup with Ultra-High Security</h2>
              <p>We prioritize your safety with advanced encryption, multi-layer authentication, and cold storage solutions. Rest assured, your digital assets are protected.</p>
              <ul className="pg-home-security__list">
                <li><span className="pg-home-check">&#10003;</span><span>Multi-layer authentication & biometric access</span></li>
                <li><span className="pg-home-check">&#10003;</span><span>Cold storage for maximum asset protection</span></li>
                <li><span className="pg-home-check">&#10003;</span><span>End-to-end encryption on every transaction</span></li>
                <li><span className="pg-home-check">&#10003;</span><span>Automatic encrypted backups</span></li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="pg-home-section" id="portfolio">
        <div className="pg-home-container">
          <div className="pg-home-portfolio__header">
            <span className="pg-home-badge">Multi-Token Support</span>
            <h2 style={{ marginTop: '1rem' }}>Effortlessly Store a Wide Range of Crypto</h2>
            <p>Manage, trade, stake, and grow your crypto portfolio all in one secure platform.</p>
          </div>
          <div className="pg-home-table-responsive">
            <table className="pg-home-token-table">
              <thead><tr><th>Asset</th><th>Price</th><th>24h Change</th><th>Market Cap</th><th /></tr></thead>
              <tbody>
                {TOKENS.map((token) => {
                  const p = prices[token.id];
                  const priceDisplay = p?.usd
                    ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: p.usd < 1 ? 6 : 2 }).format(p.usd)
                    : '—';
                  const change = p?.usd_24h_change;
                  const changeDisplay = typeof change === 'number' ? `${change >= 0 ? '+' : ''}${change.toFixed(2)}%` : '—';
                  const capDisplay = p?.usd_market_cap ? formatMarketCap(p.usd_market_cap) : '—';
                  const changeClass = typeof change === 'number' ? (change > 0 ? 'pg-home-price-up' : change < 0 ? 'pg-home-price-down' : '') : '';
                  return (
                    <tr key={token.id}>
                      <td>
                        <div className="pg-home-token-name">
                          <div className={`pg-home-token-icon ${token.iconClass}`}>{token.icon}</div>
                          <div>{token.name} <span style={{ color: 'var(--pg-text-muted)', fontWeight: 400 }}>{token.symbol}</span></div>
                        </div>
                      </td>
                      <td>{priceDisplay}</td>
                      <td className={changeClass} style={changeClass ? undefined : { color: 'var(--pg-text-muted)' }}>{changeDisplay}</td>
                      <td>{capDisplay}</td>
                      <td><Link to="/auth/login" className="pg-home-btn pg-home-btn-outline" style={{ padding: '8px 18px', fontSize: '0.75rem' }}>Trade</Link></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="pg-home-section">
        <div className="pg-home-container">
          <div className="pg-home-cta-banner">
            <h2>Ready to Take Control of Your Crypto?</h2>
            <p>Stake, swap, and trade in one place. Join thousands of users who trust PRA Group for their digital assets.</p>
            <Link to="/auth/signup" className="pg-home-btn pg-home-btn-primary">Get Started — It&apos;s Free</Link>
          </div>
        </div>
      </section>

      <section className="pg-home-section" id="faq">
        <div className="pg-home-container">
          <div className="pg-home-faq__header">
            <span className="pg-home-badge">FAQ</span>
            <h2 style={{ marginTop: '1rem' }}>Got Questions?</h2>
            <p>Check out our FAQ for all the information you need to get started.</p>
          </div>
          <div className="pg-home-faq__list">
            {FAQ_ITEMS.map((item, index) => (
              <div key={index} className={`pg-home-faq-item ${openFaqIndex === index ? 'pg-home-faq-item--open' : ''}`}>
                <button type="button" className="pg-home-faq-item__q" aria-expanded={openFaqIndex === index} onClick={() => toggleFaq(index)}>
                  {item.q}<span className="pg-home-chevron">&#9660;</span>
                </button>
                <div className="pg-home-faq-item__a"><p>{item.a}</p></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer className="pg-home-footer" id="contact">
        <div className="pg-home-container">
          <div className="pg-home-footer__grid">
            <div className="pg-home-footer__brand">
              <Link to="/" className="pg-home-nav__logo" style={{ fontSize: '1.25rem' }}><img style={{width:"120px"}} src={homeLogo} alt="PRA Group Logo" /></Link>
              <p>A trusted platform built to streamline your cryptocurrency journey with confidence and ease.</p>
              <p><b>Registered office address:</b> Level 11 Riverside House, 2a Southwark Bridge Road, London, England, SE1 9HA</p>
            </div>
            <div className="pg-home-footer__col">
              <h4>Product</h4>
              <ul>
                <li><Link to="/auth/login">Wallet</Link></li>
                <li><a href="#features">Staking</a></li>
                <li><Link to="/auth/login">Exchange</Link></li>
                <li><a href="#portfolio">Portfolio</a></li>
              </ul>
            </div>
            <div className="pg-home-footer__col">
              <h4>Legal</h4>
              <ul>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-of-service">Terms of Service</Link></li>
                <li><Link to="/cookie-policy">Cookie Policy</Link></li>
                <li><Link to="/compliance">Compliance</Link></li>
              </ul>
            </div>
          </div>
          <div className="pg-home-footer__bottom">
            <span>&copy; 2026 PRA Group. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
